import moment from 'moment';

export default function (partOfDay, startAt = 6, endAt = 24) {
  const data = [];

  if (partOfDay === 0) {
    let currentH = startAt;
    for (let i = 0; currentH <= 11; i++) {
      const h1 = moment({ hour: currentH }).format('HH:mm');
      const h2 = moment({ hour: currentH, minute: 30 }).format('HH:mm');

      data.push(Array(7).fill(h1), Array(7).fill(h2));
      currentH++;
    }
  } else if (partOfDay === 1) {
    let currentH = 12;
    for (let i = 0; currentH <= 17; i++) {
      const h1 = moment({ hour: currentH }).format('HH:mm');
      const h2 = moment({ hour: currentH, minute: 30 }).format('HH:mm');

      data.push(Array(7).fill(h1), Array(7).fill(h2));
      currentH++;
    }
  } else if (partOfDay === 2) {
    let currentH = 18;
    for (let i = 0; currentH <= endAt - 1; i++) {
      const h1 = moment({ hour: currentH }).format('HH:mm');
      const h2 = moment({ hour: currentH, minute: 30 }).format('HH:mm');

      data.push(Array(7).fill(h1), Array(7).fill(h2));
      currentH++;
    }
  }
  return data;
}
